<template>
  <custom-dialog width="850px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules" label-width="138px">
        <el-form-item style="padding-left: 10px" v-if="isOrder" :label="$t('crm_contract_approval.zbskyqts')" prop="hqOverdueDays" class="is-required">
          <el-input placeholder="" v-model="form.hqOverdueDays" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item style="padding-left: 10px" v-if="model.data.partyAId !== model.data.hqId && isOrder" :label="$t('crm_contract_approval.jfskyqts')" prop="jvOverdueDays" class="is-required">
          <el-input placeholder="" v-model="form.jvOverdueDays" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item style="padding-left: 10px" :label="$t('crm_contract_approval.sfsptg')" prop="isPass" class="is-required">
          <el-switch v-model="form.isPass" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item style="padding-left: 10px" :label="$t('crm_contract_approval.shen_pi_yi_jian')" prop="remark">
          <el-input type="textarea" :rows="4" placeholder="" v-model="form.remark" style="width: 600px"></el-input>
        </el-form-item>
      </el-form>
      <div></div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
// import moment from 'moment';
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        isPass: 1,
        remark: '',
        // date: '',
        hqOverdueDays: '',
        jvOverdueDays: '',
      },
    };
  },
  mounted() {
    this.$setFormatData(this.form, this.model.data);
  },
  computed: {
    rules() {
      return {
        hqOverdueDays: [{ required: true, message: this.$t('Common.com_required') }],
        jvOverdueDays: [{ required: true, message: this.$t('Common.com_required') }],
        remark: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]) },
        ],
      };
    },
    isOrder() {
      // 20-租赁订单  21续租合同  31协议订单
      return ['20', '21', '31'].includes(`${this.model.data.contractType}`);
    },
  },

  methods: {
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.saveInsert();
      });
    },
    // 保存新增
    saveInsert: function () {
      const workflowType = this.model.approveType;
      const bizId = this.model.data.bizId;
      const basePath = this.form.isPass ? apis.apsApproveApprovalAapproveYes : apis.apsApproveApprovalApproveNo;
      const fullPath = `${basePath}/${workflowType}/${bizId}`;
      const bizData = {};
      bizData.hqOverdueDays = this.form.hqOverdueDays;
      if (this.model.data.partyAId === this.model.data.hqId) {
        bizData.jvOverdueDays = this.form.hqOverdueDays;
      } else {
        bizData.jvOverdueDays = this.form.jvOverdueDays;
      }
      this.$postJSON(fullPath, { remark: this.form.remark, bizData }, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>
